/**
 * @generated SignedSource<<026508ee18c7dc0d4a609f905ec2b77f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgSpaceItemInstalled_StorecastSpace$data = {
  readonly id: string;
  readonly installedDashboardsCount: number;
  readonly installedStoresCount: number;
  readonly storesCount: number;
  readonly " $fragmentType": "OrgSpaceItemInstalled_StorecastSpace";
};
export type OrgSpaceItemInstalled_StorecastSpace$key = {
  readonly " $data"?: OrgSpaceItemInstalled_StorecastSpace$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgSpaceItemInstalled_StorecastSpace">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgSpaceItemInstalled_StorecastSpace",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "installedDashboardsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "installedStoresCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storesCount",
      "storageKey": null
    }
  ],
  "type": "StorecastSpace",
  "abstractKey": null
};

(node as any).hash = "597e97b1754f392caa7c767602f14a21";

export default node;
